import { render } from "./snackbarDelete.vue?vue&type=template&id=18ff4ff8&scoped=true"
import script from "./snackbarDelete.vue?vue&type=script&lang=js"
export * from "./snackbarDelete.vue?vue&type=script&lang=js"

import "./snackbarDelete.vue?vue&type=style&index=0&id=18ff4ff8&scoped=true&lang=css"

import exportComponent from "/Users/charcoaldev/Documents/GitHub/beardrug-pos/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ff4ff8"]])

export default __exports__